import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "./Messages.scss";

interface IMessages {
  page: string;
}

const Messages = ({ page }: IMessages) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const account = searchParams.get("account") || "";
  const [modalActive, setModalActive] = useState(false);
  const handleOpenModal = () => {
    setModalActive((prev) => !prev);
  };

  useEffect(() => {
    if (account === "messages") {
      setModalActive(true);
    } else {
      setModalActive(false);
    }
  }, []);

  return (
    <div className={`user-profile-nav ${modalActive ? "active" : ""}`}>
      <div className="user-profile-nav-header" onClick={handleOpenModal}>
        <i className="user-profile-nav-icon bc-i-message" />
        <span className="user-profile-nav-title">{t("admin.Messages")}</span>
        <i className="  count-blink-even " data-badge="" />
        <i
          className={`user-profile-nav-arrow bc-i-small-arrow-${
            modalActive ? "up" : "down"
          }`}
        />
      </div>
      <div className="user-profile-nav-list">
        <Link
          className={`user-profile-nav-item ellipsis ${
            page === "inbox" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=messages&page=inbox",
          }}
        >
          {t("admin.Inbox")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <Link
          className={`user-profile-nav-item ellipsis ${
            page === "sent" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=messages&page=sent",
          }}
        >
          {t("admin.Sent")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <Link
          className={`user-profile-nav-item ellipsis ${
            page === "new" ? "active" : ""
          }`}
          to={{
            search: "profile=open&account=messages&page=new",
          }}
        >
          {t("admin.New")}
          <i className="  count-blink-even " data-badge="" />
        </Link>
        <div className="user-profile-nav-item-cursor " />
      </div>
    </div>
  );
};

export { Messages };
